<template>
    <div v-show="showLangDropDown && getLanguage && getLanguage.length">
        <!-- <div class="dropdown-text">
            <label for="language" class="mobileLang">
                {{ $t("language.language") }}
            </label>
            &nbsp;
        </div> -->
        <v-select
            v-if="$breakpoint.lgAndUp"
            v-model="selected"
            :items="getLanguage"
            item-text="name"
            item-value="code"
            :searchable="false"
            :class="$breakpoint.smAndDown ? 'mobileLangDrop' : 'lang'"
            outlined
            dense
            @input="onChange"
        >
            <template #item="data"
                >{{ data.item.name + " (" + data.item.regional_name + ")" }}
            </template>
        </v-select>

        <v-container v-else>
            <v-row scrollable>
                <v-dialog
                    v-model="dialog"
                    scrollable
                    max-width="300px"
                    class="select_lang"
                >
                    <template v-slot:activator="{ on }">
                        <v-btn
                            class="lang_btn f16 font-weight-bold d-flex justify-space-between"
                            dark
                            outlined
                            v-on="on"
                        >
                            {{ langName != "" ? langName : "English" }}

                            <i
                                aria-hidden="true"
                                size="16"
                                class="v-icon notranslate mdi mdi-chevron-down theme--dark"
                            ></i>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            {{ $t("language.language") }}</v-card-title
                        >
                        <v-divider></v-divider>
                        <v-card-text
                            class="justify-content-start"
                            style="height: 300px"
                        >
                            <v-list-item
                                class="pa-0"
                                v-for="item in getLanguage"
                                :key="item.code"
                                @click="
                                    () => {
                                        onChange(item.code, item.name)
                                        dialog = false
                                    }
                                "
                            >
                                <v-list-item-content>
                                    <v-list-item-title
                                        v-text="
                                            item.name +
                                            '  (' +
                                            item.regional_name +
                                            ')'
                                        "
                                    ></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="dialog = false"
                            >
                                Close
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import constant from "~/constant"

export default {
    data() {
        return {
            langName: "",
            dialog: false,
            dialogm1: "",
            showLangDropDown: constant.langDropDown,
            selected: this.$i18n.getLocaleCookie("i18n_redirected")
                ? this.$i18n.getLocaleCookie("i18n_redirected")
                : this.isMobile()
        }
    },
    //   mounted() {
    //   this.mobile = this.isMobile()
    // },

    computed: {
        version() {
            return this.$store.state.profile.appversion
        },
        availableLocales() {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            return this.$i18n.locales.sort(function (a, b) {
                return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
            })
        },
        getLanguage() {
            let langauageList
            if (this.version.projectCode === "bd-new") {
                langauageList =
                    this.$store.state.languageMaster.languages.filter(function (
                        value
                    ) {
                        return value.code === "en" || value.code === "bn"
                    })
            } else {
                langauageList = this.$store.state.languageMaster.languages
            }
            return langauageList
        }
    },
    created() {
        if (process.client) {
            this.langName = localStorage.getItem("name")
                ? localStorage.getItem("name")
                : ""
        }
    },
    beforeMount() {
        this.showLangDropDowns()
    },
    methods: {
        isMobile() {
            return navigator.language.substring(0, 2)
        },

        onChange(locale, name) {
            if (process.client) {
                localStorage.setItem("name", name)
                const language = locale.toLocaleLowerCase()
                this.$i18n.setLocaleCookie(language)
                this.switchLocalePath(language)
                if (process.client) {
                    window.location.reload(true)
                }
                localStorage.setItem("lang_code", language)
                // this.$router.replace(this.switchLocalePath(language))
            }
        },
        showLangDropDowns() {
            if (!this.showLangDropDown) {
                this.selected = "en"
                this.$i18n.setLocaleCookie(null)
                this.switchLocalePath(this.selected)
                // this.$router.go('/')
                // eslint-disable-next-line no-unused-expressions
                // eslint-disable-next-line no-unused-expressions
                this.$i18n.fallbackLocale
                // this.onChange(this.selected)
            }
        },
        text(item) {
            return item.code.charAt(0).toUpperCase() + item.code.slice(1)
        }
    }
}
</script>
<style lang="scss" scoped>
@media only screen and (min-width: 1263px) and (max-width: 2499px) {
    .dropdown-text {
        display: none;
    }
}
.v-dialog__content--active {
    z-index: 200004 !important;
}
.lang_btn {
    width: 90%;
    height: 80px;
    border: none;
    border-bottom: 1px solid grey;
    display: flex;
    justify-content: center;
    border-radius: 0px;
}
</style>
